import Vue from 'vue'
import VueRouter from 'vue-router'
// import login from '@/views/mobile/login'
import login from '@/views/mobile/loginCopy'
// import epas from '@/views/mobile/epas'
import epasCopyReport from '@/views/mobile/epasCopyReport'
import epasCopyAudit from '@/views/mobile/epasCopyAudit'
import epasCopyReward from '@/views/mobile/epasCopyReward'

Vue.use(VueRouter)

export default [
    // {
    //     path: '/',
    //     name: '/mobile/login',
    //     component: login,
    //     meta: {requireAuth: false}
    // },
    {
        path: '/',
        name: '/mobile/loginCopy',
        component: login,
        meta: {requireAuth: false}
    },
    // {
    //     path: '/home',
    //     name: '/mobile/home',
    //     component: epas,
    //     meta: {requireAuth: true}
    // },

    // 上报
    {
        path: '/report',
        name: '/mobile/report',
        component: epasCopyReport,
        meta: {requireAuth: true}
    },

    // 审核
    {
        path: '/audit',
        name: '/mobile/audit',
        component: epasCopyAudit,
        meta: {requireAuth: true}
    },
    // 奖惩
    {
        path: '/reward',
        name: '/mobile/reward',
        component: epasCopyReward,
        meta: {requireAuth: true}
    },
    {
        path: '/person_new',
        name: '/mobile/person_new',
        component: () => import('@/components/mobile/personal_work/new'),
        meta: {requireAuth: true}
    },
    {
        path: '/person_newCopy',
        name: '/mobile/person_newCopy',
        component: () => import('@/components/mobile/personal_work/newCopy'),
        meta: {requireAuth: true}
    },
    {
        path: '/person_toBeReviewed',
        name: '/mobile/person_toBeReviewed',
        component: () => import('@/components/mobile/personal_work/toBeReviewed'),
        meta: {requireAuth: true}
    },
    {
        path: '/person_toBeReviewedCopy',
        name: '/mobile/person_toBeReviewedCopy',
        component: () => import('@/components/mobile/personal_work/toBeReviewedCopy'),
        meta: {requireAuth: true}
    },
    {
        path: '/person_rejection',
        name: '/mobile/person_rejection',
        component: () => import('@/components/mobile/personal_work/rejection'),
        meta: {requireAuth: true}
    },
    {
        path: '/person_rejectionCopy',
        name: '/mobile/person_rejectionCopy',
        component: () => import('@/components/mobile/personal_work/rejectionCopy'),
        meta: {requireAuth: true}
    },
    {
        path: '/person_reviewed',
        name: '/mobile/person_reviewed',
        component: () => import('@/components/mobile/personal_work/reviewed'),
        meta: {requireAuth: true}
    },
    {
        path: '/person_reviewedCopy',
        name: '/mobile/person_reviewedCopy',
        component: () => import('@/components/mobile/personal_work/reviewedCopy'),
        meta: {requireAuth: true}
    },
    {
        path: '/staffRewardAndPunishments',
        name: '/mobile/director_review',
        component: () => import('@/components/mobile/director_review/staffRewardAndPunishments'),
        meta: {requireAuth: true}
    },
    {
        path: '/team_new',
        name: '/mobile/team_new',
        component: () => import('@/components/mobile/team_work/new'),
        meta: {requireAuth: true}
    },
    {
        path: '/team_newCopy',
        name: '/mobile/team_newCopy',
        component: () => import('@/components/mobile/team_work/newCopy'),
        meta: {requireAuth: true}
    },
    {
        path: '/toBeConfirm',
        name: '/mobile/toBeConfirm',
        component: () => import('@/components/mobile/team_work/toBeConfirm'),
        meta: {requireAuth: true}
    },
    {
        path: '/toBeConfirmCopy',
        name: '/mobile/toBeConfirmCopy',
        component: () => import('@/components/mobile/team_work/toBeConfirmCopy'),
        meta: {requireAuth: true}
    },
    {
        path: '/toBeReviewed',
        name: '/mobile/toBeReviewed',
        component: () => import('@/components/mobile/team_work/toBeReviewed'),
        meta: {requireAuth: true}
    },
    {
        path: '/rejection',
        name: '/mobile/rejection',
        component: () => import('@/components/mobile/team_work/rejection'),
        meta: {requireAuth: true}
    },
    {
        path: '/rejectionCopy',
        name: '/mobile/rejectionCopy',
        component: () => import('@/components/mobile/team_work/rejectionCopy'),
        meta: {requireAuth: true}
    },
    {
        path: '/reviewed',
        name: '/mobile/reviewed',
        component: () => import('@/components/mobile/team_work/reviewed'),
        meta: {requireAuth: true}
    },
    {
        path: '/reviewedCopy',
        name: '/mobile/reviewedCopy',
        component: () => import('@/components/mobile/team_work/reviewedCopy'),
        meta: {requireAuth: true}
    },
    {
        path: '/toBeSubmitted',
        name: '/mobile/toBeSubmitted',
        component: () => import('@/components/mobile/team_work/toBeSubmitted'),
        meta: {requireAuth: true}
    },
    {
        path: '/toBeSubmittedCopy',
        name: '/mobile/toBeSubmittedCopy',
        component: () => import('@/components/mobile/team_work/toBeSubmittedCopy'),
        meta: {requireAuth: true}
    },
    //部门主管
    {
        path: '/individualPendingReview',
        name: '/mobile/individualPendingReview',
        component: () => import('@/components/mobile/personal_review/IndividualPendingReview'),
        meta: {requireAuth:true}
    },
    {
        path: '/individualPendingReviewCopy',
        name: '/mobile/individualPendingReviewCopy',
        component: () => import('@/components/mobile/personal_review/IndividualPendingReviewCopy'),
        meta: {requireAuth:true}
    },
    {
        path: '/personalReviewed',
        name: '/mobile/personalReviewed',
        component: () => import('@/components/mobile/personal_review/reviewed'),
        meta: {requireAuth:true}
    },
    {
        path: '/personalReviewedCopy',
        name: '/mobile/personalReviewedCopy',
        component: () => import('@/components/mobile/personal_review/reviewedCopy'),
        meta: {requireAuth:true}
    },
    {
        path: '/personalRejection',
        name: '/mobile/personalRejection',
        component: () => import('@/components/mobile/personal_review/personalRejection'),
        meta: {requireAuth:true}
    },
    {
        path: '/personalRejectionCopy',
        name: '/mobile/personalRejectionCopy',
        component: () => import('@/components/mobile/personal_review/personalRejectionCopy'),
        meta: {requireAuth:true}
    },
    {
        path: '/auditHistory',
        name: '/mobile/auditHistory',
        component: () => import('@/components/mobile/personal_review/auditHistory'),
        meta: {requireAuth:true}
    },

    {
        path: '/auditHistoryCopy',
        name: '/mobile/auditHistoryCopy',
        component: () => import('@/components/mobile/personal_review/auditHistoryCopy'),
        meta: {requireAuth:true}
    },
    //团队
    {
        path: '/teamToBeReviewed',
        name: '/mobile/teamToBeReviewed',
        component: () => import('@/components/mobile/team_review/teamToBeReviewed'),
        meta: {requireAuth:true}
    },
    {
        path: '/teamToBeReviewedCopy',
        name: '/mobile/teamToBeReviewedCopy',
        component: () => import('@/components/mobile/team_review/teamToBeReviewedCopy'),
        meta: {requireAuth:true}
    },
    {
        path: '/teamReviewed',
        name: '/mobile/teamReviewed',
        component: () => import('@/components/mobile/team_review/teamReviewed'),
        meta: {requireAuth:true}
    },
    {
        path: '/teamReviewedCopy',
        name: '/mobile/teamReviewedCopy',
        component: () => import('@/components/mobile/team_review/teamReviewedCopy'),
        meta: {requireAuth:true}
    },
    {
        path: '/teamRejection',
        name: '/mobile/teamRejection',
        component: () => import('@/components/mobile/team_review/teamRejection'),
        meta: {requireAuth:true}
    },
    {
        path: '/teamRejectionCopy',
        name: '/mobile/teamRejectionCopy',
        component: () => import('@/components/mobile/team_review/teamRejectionCopy'),
        meta: {requireAuth:true}
    },
    {
        path: '/teamAuditHistory',
        name: '/mobile/teamAuditHistory',
        component: () => import('@/components/mobile/team_review/teamAuditHistory'),
        meta: {requireAuth:true}
    },
    {
        path: '/teamAuditHistoryCopy',
        name: '/mobile/teamAuditHistoryCopy',
        component: () => import('@/components/mobile/team_review/teamAuditHistoryCopy'),
        meta: {requireAuth:true}
    },
    /*个人信息*/
    {
        path: '/my',
        name: '/mobile/my',
        component: () => import('@/components/mobile/myInfo/my'),
        meta: {requireAuth: true}
    },
    // 问卷
    {
        path: '/generateQuestionnaire',
        name: '/mobile/generateQuestionnaire',
        component: () => import('@/components/mobile/questionnaire/generateQuestionnaire'),
        meta: {requireAuth: true}
    },
    {
        path: '/fillInQuestionnaire',
        name: '/mobile/fillInQuestionnaire',
        component: () => import('@/components/mobile/questionnaire/fillInQuestionnaire'),
        meta: {requireAuth: false}
    }
]
